import {
  CcfBox,
  CcfButton,
  CcfCloseIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './ccf-contact-history-modal.module.scss';
import { Dialog } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfContactHistoryModalProps {
  handleModalClose: () => void;
  renderIconForSkill: any;
  formatDateTimeHandler: any;
  contact: any;
  open: boolean;
}

/**
 * Contact History Details Modal
 * @example -
 */
export function CcfContactHistoryModal(props: CcfContactHistoryModalProps) {
  const {
    handleModalClose,
    renderIconForSkill,
    formatDateTimeHandler,
    contact,
    open,
  } = props;
  return (
    <CcfBox>
      <Dialog
        onClose={handleModalClose}
        aria-labelledby={contact.customer}
        open={open}
        fullWidth={true}
      >
        <CcfBox className={styles.modalContainer}>
          <CcfBox className={styles.modalHeader}>
            <CcfTypography className={`${styles.txt} ${styles.title}`}>
              {contact.customer}
            </CcfTypography>
            <CcfCloseIcon
              className={styles.closeIcon}
              onClick={handleModalClose}
            />
          </CcfBox>
          <CcfBox className={styles.modalContent}>
            <CcfBox className={styles.contactChannel}>
              {renderIconForSkill(contact.skill)}
              <CcfTypography className={styles.txt}>
                {contact.channel}
              </CcfTypography>
            </CcfBox>
            <CcfBox>
              <CcfTypography className={styles.txt}>
                {formatDateTimeHandler(contact.time)}
              </CcfTypography>
            </CcfBox>
          </CcfBox>
          <CcfBox className={styles.modalFooter}>
            <CcfButton className={styles.btn} onClick={handleModalClose}>
              <CcfTypography className={styles.btnText}>Cancel</CcfTypography>
            </CcfButton>
          </CcfBox>
        </CcfBox>
      </Dialog>
    </CcfBox>
  );
}

export default CcfContactHistoryModal;
